


<div class="modal-header">

  {{ 'LABELS.SELECT_CREDIT_NOTE(S)' | translate}}


</div>

<div class="modal-body pt-0 ms-lg-3 me-lg-3 ms-xl-3 me-xl-3" style="border-bottom: 1px solid gray;">
<div >
  <div class="row " style="border-bottom: 1px solid gray;" *ngIf="payData.creditNotes && payData.creditNotes.length">
    <div class="col-12 p-1 pt-lg-3 pt-xl-3 pb-lg-3 pb-xl-3">
      <div class="row font-12 align-items-center" >
        <div class="col-4 d-flex align-content-center ps-2">
          <input type="checkbox"  [(ngModel)]="allCreditNotesSelected" class="form-check-input m-0 p-0"
            (ngModelChange)="creditNotesSelectionToggled()" />
          <!-- <label class="form-check-label ms-1 mt-1">{{ 'LABELS.SELECT_MULTIPLE_BY' | translate}} </label> -->
          <label class="form-check-label ms-1 mt-0 font-12 ps-2" style="padding: 0; margin-top: 4px">{{ 'LABELS.SELECT_ALL' | translate}}</label>
        </div>
        <div class="col-6" >
          <select class="form-select form-select-sm width100" [(ngModel)]="creditNotesSelectConfig.sortType" (ngModelChange)="sortCreditNotes()">
            <option *ngFor="let option of creditNotesSelectConfig.sortOptions" [ngValue]="option.text">{{option.label | translate}}</option>
          </select>
        </div>
        <div class="col-2 text-end" >
          <button type="button" (click)="sortCreditNotes()" class="btn btn-xs fis-btn waves-effect waves-light"
          [disabled]="creditNotesSelectConfig.sortType === 'Optimal Selection'">
            <i *ngIf="creditNotesSelectConfig.sortDir === 'asc'" class="fe-arrow-down"></i>
            <i *ngIf="creditNotesSelectConfig.sortDir === 'desc'" class="fe-arrow-up"></i></button>
        </div>
      </div>
    </div>
  </div>
  <div   *ngIf="!payData.creditNotes || !payData.creditNotes.length" >
    <label  color="danger">
      <strong >
        <i class="fa fa-warning" aria-hidden="true"></i>
        {{ 'LABELS.NO_USABLE_CREDIT' | translate}}
      </strong>
    </label>
  </div>
  <div class="row creditNoteMaxScreen font-11 font-lg-12 font-xl-12">
    <!-- <div class="col-5 fw-bold">{{ 'LABELS.CREDIT_NOTE' | translate}}</div>
  <div class="col-3 fw-bold">{{ 'LABELS.AMOUNT' | translate}}</div>
  <div class="col-2 fw-bold" style="white-space: nowrap">{{ 'LABELS.CREDIT_NOTE_DATE' | translate}}</div>
  </div> -->
  <table class="table table-sm table-hover m-0 text-nowrap nowrap table-sortable">
    <thead class="thead-light">
      <tr>
        <th></th>
        <th>{{ 'LABELS.CREDIT_NOTE' | translate}}</th>
        <th class="text-end">{{ 'LABELS.AMOUNT' | translate}}</th>
        <th>{{ 'LABELS.CREDIT_NOTE_DATE' | translate}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of payData.creditNotes">
        <td class="m-0 pe-0 col-1">
          <input class="form-check-input m-0 p-0" id="chkCNSelectForPay_{{item.docId}}" type="checkbox" name="CR_{{item.docNo}}"
                 [(ngModel)]="item.selected" [disabled]="item.disabled" 
                (ngModelChange)="creditNoteSelected()" />
        </td>
        <td class="m-0 pe-0 col-5">
          {{item.docNo}}
        </td>
        <td class="text-end amount m-0 pe-0 col-3">
          {{item.docAmtDetails.dispalyStr}}
        </td>
        <td class="m-0 pe-0 col-2">
          {{item.cnDate}}
        </td>
        <td class="m-0 pe-0 col-1" *ngIf="item.tags && item.tags.length">
            <div *ngFor="let tag of item.tags">
              <span class="divbatchtag">{{tag.desc}}</span>
            </div>
        </td>
        
      </tr>
    </tbody>
  </table>
</div>
</div>


<div class="mt-0 mt-lg-3 mt-xl-3 font-11 font-lg-12 font-xl-12" *ngIf="payData.creditNotes && payData.creditNotes.length">
  <div class="row mb-2">
    <div  class="col-6">
      <strong>{{ 'LABELS.SELECTED_AMOUNT' | translate}}: {{payData.selectedCreditNotesAmount | inrdisplay: payData.invoiceData.currCode}}</strong>
    </div>
    <div class="col-6 p-0"  *ngIf="!payData.hideBankAmt">
      <strong>{{ 'LABELS.FINAL_PAY_AMOUNT' | translate}}: {{payData.bankAmt | inrdisplay: payData.invoiceData.currCode}}</strong>
    </div>
  </div>
  <div class="row button-list mt-0 mt-lg-3 mt-xl-3 text-center">

    <div >
      <button id="btnClearCNSelection" class="btn fis-btn" (click)="clearCreditNotesSelection()">{{ 'LABELS.CLEAR' | translate}}
      </button>

      <button id="btnCloseCNSelection" class="btn  fis-btn" (click)="dismiss()" strong>{{getButtonText()}}
      </button>
    </div>
  </div>
</div>




